<template>
  <div id="app">
    <el-alert
      class="alert alert-info"
      title="This website uses cookies to handle login using Zenodo. Your usage information stay on your computer and are not provided to Pollen Metrology. They are not used for advertising or analytics reasons."
      type="info"
      v-if="!acceptation"
      @close="handleClose()"
    />
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  props: {
    zenodoAuth: Object,
  },
  data() {
    const acceptation = this.$cookies.get('acceptation')
    return {
      acceptation,
    }
  },
  mounted() {
  },
  methods: {
    handleClose() {
      console.log('close')
      this.$cookies.set('acceptation', true)
    },
  },
}
</script>

<style lang="scss">

@import "./themes.scss";

body {
  font-family: "Helvetica Neue", Helvetica, sans-serif
}
#app {
  min-height: 100vh;
  box-sizing: border-box;
  display: block;
}

.main {
  padding: 0px 10px;
  max-width: $maxWidth;
  margin: auto;

  text-align: center;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
}

.alert {
  border-radius: 0;

  &.alert-info {
    background-color: #409EFF;
    color: white;

    i {
      color: white;
    }
  }

  &.alert-error {
    background-color: #EA4E51;
    color: white;

    i {
      color: white;
    }
  }
}

</style>
